module.exports = __webpack_public_path__ + "static/3A841E_2_0-431884563f1e06cd4212fc5d82d4c12f.woff";